import React, { useEffect } from 'react'
import { images } from 'Assets/Images'
import { ModalPrinterTemplates } from 'Views/Printer/components/ModalPrinterTemplates'
import { usePrinterContext } from 'state/context/PrinterTemplatesContext'
import { useHistory } from 'react-router-dom'
import { useGeneratePrinter } from './hooks/useGeneratePrinter'
import { AddMoreTemplatesButton } from './components/AddMoreTemplatesButton'
import { ModalZoomAlert } from 'Views/Printer/components/ModalZoomAlert'

export const TemplatesSection = () => {
  const history = useHistory()
  const {
    selectedTemplates,
    selectedTemplateType,
    setAllTemplatesContent,
    allTemplatesContent,
    currentPage,
  } = usePrinterContext()
  const { generateMultiPagePDF, printedUrl } = useGeneratePrinter()

  const [zoomAlert, setZoomAlert] = React.useState(false)
  const [openTemplateModal, setOpenTemplateModal] = React.useState(false)
  const handleClose = () => setOpenTemplateModal(false)
  const handleShow = () => setOpenTemplateModal(true)
  const hasSquareTemplate = selectedTemplates?.some(
    template => template === 'square-1'
  )
  const hasDoubleSquareTemplate = selectedTemplates?.some(
    template => template === 'square-2'
  )
  const hasSquare3Template = selectedTemplates?.some(
    template => template === 'square-3'
  )
  const hasSquare4Template = selectedTemplates?.some(
    template => template === 'square-4'
  )
  const hasSquare5Template = selectedTemplates?.some(
    template => template === 'square-5'
  )
  const hasSquare6Template = selectedTemplates?.some(
    template => template === 'square-6'
  )

  const printed = printedUrl !== ''

  const isSpecial = selectedTemplateType?.key === 'SPECIAL_CMF'

  const templates = [
    {
      name: 'Tonga y Bin',
      condition: hasSquareTemplate,
      type: 'square-1',
      image: images.printer.square,
      size: '11" x 8.5"',
      orientation: 'Horizontal',
    },
    {
      name: 'Frente Góndola',
      condition: hasDoubleSquareTemplate,
      type: 'square-2',
      image: images.printer.doubleSquare,
      size: '8.5" x 5.5"',
      orientation: 'Horizontal',
    },
    {
      name: 'Frente Góndola',
      condition: hasSquare3Template,
      type: 'square-3',
      image: images.printer.squares,
      size: '4" x 5"',
      orientation: 'Vertical',
      isSpecial,
    },
    {
      name: 'Frente Góndola',
      condition: hasSquare4Template,
      type: 'square-4',
      image: images.printer.squares,
      size: '5.5" x 8.5"',
      orientation: 'Vertical',
      isSpecial,
    },
    {
      name: 'Tonga',
      condition: hasSquare5Template,
      type: 'square-5',
      image: images.printer.square,
      size: '11" x 8.5"',
      orientation: 'Horizontal (con precio CMF)',
      isSpecial,
    },
    {
      name: 'Frente Góndola',
      condition: hasSquare6Template,
      type: 'square-6',
      image: images.printer.doubleSquare,
      size: '8.5" x 5.5"',
      orientation: 'Horizontal (con precio CMF)',
      isSpecial,
    },
  ]

  const visibleTemplates = templates.filter(template => template.condition)
  const lastVisibleIndex = visibleTemplates.length - 1

  const handleSelectTemplate = template => {
    setAllTemplatesContent(prev => [
      ...prev.map(content => {
        if (content.page === currentPage) {
          return {
            ...content,
            content: { products: [] },
            template: [template],
          }
        }
        return content
      }),
    ])
  }

  useEffect(() => {
    if (!selectedTemplateType?.key) {
      history.push('/printer')
    }
    const hasAllTemplatesContent = allTemplatesContent?.find(
      content => content?.page === currentPage
    )?.template?.length
    if (!hasAllTemplatesContent) {
      handleSelectTemplate(selectedTemplates?.[0])
    }
  }, [selectedTemplateType])

  function detectarNavegador() {
    const ua = navigator.userAgent
    return /Chrome/.test(ua) && !/Edg|OPR/.test(ua)
      ? 'Google Chrome'
      : /Firefox/.test(ua)
      ? 'Mozilla Firefox'
      : /Safari/.test(ua) && !/Chrome/.test(ua)
      ? 'Apple Safari'
      : /Edg/.test(ua)
      ? 'Microsoft Edge'
      : /OPR|Opera/.test(ua)
      ? 'Opera'
      : /Trident|MSIE/.test(ua)
      ? 'Internet Explorer'
      : 'Navegador desconocido'
  }

  return (
    <>
      <div className="printer-preview-right-templates-wrapper">
        {visibleTemplates.map((template, index) => (
          <div key={template.type} style={{ position: 'relative' }}>
            <button
              disabled={template.isSpecial || printed}
              className="printer-modal-content-option"
              onClick={() => handleSelectTemplate(template.type)}>
              <div
                className="printer-modal-content-image-wrapper"
                style={{
                  ...(allTemplatesContent
                    .find(content => content.page === currentPage)
                    ?.template?.includes(template.type) && {
                    border: '2px solid #022767',
                  }),
                }}>
                <img
                  src={template.image}
                  alt=""
                  className="printer-modal-content-image"
                />
              </div>
              <p className="printer-modal-content-text">
                {template.name}
                <br />
                {template.size}
                <br />
                {template.orientation}
              </p>
            </button>
            {/* Mostrar el botón solo si es el último elemento visible */}
            {index === lastVisibleIndex && (
              <AddMoreTemplatesButton handleShow={handleShow} />
            )}
          </div>
        ))}
        <div className="printer-finish-button-wrapper">
          <button
            onClick={() => {
              const browser = detectarNavegador()
              let browserZoomLevel
              let hasCorrectZoomLevel

              if (
                browser === 'Mozilla Firefox' ||
                browser === 'Microsoft Edge'
              ) {
                browserZoomLevel = Math.round(window.devicePixelRatio * 100)
                hasCorrectZoomLevel =
                  browserZoomLevel === 100 ||
                  browserZoomLevel === 150 ||
                  browserZoomLevel === 200
              } else {
                const logicalWidth = window.innerWidth
                const physicalWidth = window.screen.width
                browserZoomLevel = Math.round(
                  (physicalWidth / logicalWidth) * 100
                )
                hasCorrectZoomLevel = browserZoomLevel === 100
              }

              if (!hasCorrectZoomLevel) return setZoomAlert(true)

              printed &&
                window.open(
                  `https://docs.google.com/viewerng/viewer?url=${printedUrl}`,
                  '_blank'
                )
              !printed && generateMultiPagePDF()
            }}
            className="printer-finish-button">
            {printed ? 'Ver PDF' : 'Imprimir etiqueta de precio'}
          </button>
        </div>
      </div>
      <ModalPrinterTemplates
        show={openTemplateModal}
        onClose={handleClose}
        withNavigation={false}
      />
      <ModalZoomAlert show={zoomAlert} onClose={() => setZoomAlert(false)} />
    </>
  )
}
